import { Slider } from '@massilia/ui'

import { Route } from '@/routes/_booking/vols.resultats'
import { formatPrice } from '@/utils/format-price'
import { useFilters } from '@/utils/use-search-params'

import { FilterDrawer } from './filter-drawer'

export interface PriceRange {
  max: number
  min: number
}

interface PriceFilterProps {
  bounds: PriceRange
}

export function PriceFilter({ bounds }: PriceFilterProps) {
  const {
    filters: { filterPriceMax, filterPriceMin },
    setFilters,
  } = useFilters(Route.id)
  // Ensure values are within bounds
  const currentMin = Math.max(filterPriceMin ?? bounds.min, bounds.min)
  const currentMax = Math.min(filterPriceMax ?? bounds.max, bounds.max)

  const handleValueChange = (values: number[]) => {
    setFilters({ filterPriceMax: values[1], filterPriceMin: values[0] })
  }

  return (
    <FilterDrawer title="Prix">
      <div className="space-y-4">
        {/* Price display */}
        <div className="flex items-center justify-between text-sm">
          <span className="font-medium text-gray-700">{formatPrice(currentMin)}</span>
          <span className="text-gray-400">—</span>
          <span className="font-medium text-gray-700">{formatPrice(currentMax)}</span>
        </div>

        {/* Slider */}
        <Slider
          max={bounds.max}
          min={bounds.min}
          onValueChange={handleValueChange}
          step={10}
          value={[currentMin, currentMax]}
        />

        {/* Bounds display */}
        <div className="flex items-center justify-between text-xs text-gray-400">
          <span>Min: {formatPrice(bounds.min)}</span>
          <span>Max: {formatPrice(bounds.max)}</span>
        </div>
      </div>
    </FilterDrawer>
  )
}
